import { type LoadingButtonTypeMap } from "@mui/lab/LoadingButton/LoadingButton";
import { type SxProps } from "@mui/material";
import { type ExtendButton } from "@mui/material/Button/Button";
import { useFormikContext } from "formik";
import { type FC } from "react";
import TriggerButton, { type TriggerButtonProps } from "../Link/TriggerButton";

export interface FormSubmitProps {
	text: {
		submitting: string;
		label: string;
	};
	disabled?: boolean;
	className?: string;
	onClick?: () => void;
	ButtonComponent?: FC<TriggerButtonProps> | ExtendButton<LoadingButtonTypeMap>;
	sx?: SxProps
}

const FormSubmit: FC<FormSubmitProps> = ({
	text,
	disabled = false,
	className = "",
	onClick = () => null,
	ButtonComponent = TriggerButton,
	...rest
}) => {
	const { isSubmitting } = useFormikContext();

	return (
		<ButtonComponent
			disabled={isSubmitting || disabled}
			className={`form-submit ${className}`}
			type="submit"
			onClick={onClick}
			{...rest}
		>
			{isSubmitting ? text.submitting : text.label}
		</ButtonComponent>
	);
};

export default FormSubmit;
